import React from 'react';

function Empty() {
  return (
    <div
      style={{
        padding: '2rem',
        maxWidth: '900px',
        margin: 'auto',
      }}
    >
      <h2>Empty Page</h2>
      <p>This page is currently empty. Check back later for updates!</p>
    </div>
  );
}

export default Empty;
